/** Раздел "Специализации" */
export default {
  name: 'Specializations',
  data() {
    return {
      /** Выбранная специализация */
      selectedSpecialization: 0,
      /** Проходит ли пользователь тест в данный момент? */
      testInProgress: false,
      /** Текущий ответ пользователя */
      currentAnswers: null,
      /** Индекс вопроса, на который в данный момент отвечает пользователь */
      currentQuestionIndex: 1,
      /** Текущая попытка прохождения теста */
      currentTry: null,
      /** Сообщение о том, что тест провален */
      testFailedMessage: '',
      isActive: false,
    };
  },
  computed: {
    /** Специализации */
    specializations() {
      return this.$store.state.specializations.items;
    },
    /** Полученные специализации */
    receivedSpecializations() {
      return this.$store.state.specializations.myItems;
    },
    /** Выбранная в данный момент специализация */
    currentSpecialization() {
      if (!this.selectedSpecialization) {
        return null;
      }
      return this.specializations.length
        ? this.specializations.filter(
          el => el.id === this.selectedSpecialization,
        )[0]
        : null;
    },
    /** Текущий вопрос */
    currentQuestion() {
      if (!this.testInProgress || !this.currentTest) {
        return null;
      }
      return this.currentTest.questions[this.currentQuestionIndex - 1];
    },
    /** Текущий тест */
    currentTest() {
      if (!this.currentSpecialization) {
        return null;
      }
      const { tests } = this.currentSpecialization;
      return tests.length ? tests[0] : null;
    },
    testPassed() {
      return this.currentTry
        && this.currentTry.results.length
        && this.currentTry.results.length === this.currentTest.questions.length
        ? this.currentTry.results.every(el => el.is_correct)
        : false;
    },
    resultMessage() {
      if (!this.currentTry) {
        return '';
      }
      const { results } = this.currentTry;
      const correctAnswersCount = results.filter(el => el.is_correct).length;
      return `Тест ${
        this.testPassed ? '' : 'не'
      } пройден. Правильных ответов ${correctAnswersCount} из ${
        results.length
      }`;
    },
    showResults() {
      if (!this.currentTry) {
        return false;
      }
      return this.currentTry.finished;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    /** Начать прохождение теста */
    startTest() {
      this.$store.getters.axl
        .post('/specializations/api/test-try', {
          profile_id: this.user.profile_id,
          test_id: this.currentTest.id,
        })
        .then((response) => {
          this.currentTry = response.data.try;
          this.testInProgress = true;
        })
        .catch((error) => {
          this.testFailedMessage = error.response.data.message;
        });
    },
    /** Прервать прохождение теста */
    cancelTest() {
      this.testInProgress = false;
      this.currentTry = null;
    },
    /** Ответить на вопрос */
    tryToAnswer() {
      this.$store.getters.axl
        .post('/specializations/api/test-try/answer', {
          profile_id: this.user.profile_id,
          try_id: this.currentTry.id,
          question_id: this.currentQuestion.id,
          answer_ids: [this.currentAnswers],
        })
        .then((response) => {
          this.currentTry = response.data.try;
          this.currentTry.finished = response.data.finished;
          this.currentAnswers = null;
          this.currentQuestionIndex = this.currentQuestionIndex + 1;
        });
    },
    /**
     * Проверить, получена ли специализация?
     * @param specializationId идентификатор специализации
     */
    checkIfSpecializationIsReceived(specializationId) {
      return (
        this.receivedSpecializations.findIndex(
          el => el.id === specializationId,
        ) !== -1
      );
    },
    /** Загрузить список полученных пользователем специализаций */
    loadMySpecializations() {
      this.$store.dispatch('specializations/GetMy');
    },
    /** Вернуться обратно к описанию специализации */
    backToDescription() {
      this.testInProgress = false;
    },
    /**
     * Задизаблить кнопки предыдущих ответов
     * @param currentTry текущая попытка прохождения теста
     */
    disableQuestionButtons(currentTry) {
      if (!currentTry) {
        return;
      }
      const navigationItems = this.$el.getElementsByTagName('nav');
      if (!navigationItems.length) {
        return;
      }
      const navigationItem = navigationItems[0];
      const numberButtons = navigationItem.getElementsByClassName('v-pagination__item');
      if (!numberButtons.length) {
        return;
      }
      numberButtons.forEach((button) => {
        button.disabled = true;
      });
    },

    /**
     * Сообщение об информаровании пользователя о количестве попыток прохождения теста
     * @param test тест
     */
    getTriesMessage(test) {
      if (!test) {
        return '';
      }
      if (test.max_tries) {
        return `Количество попыток прохождения теста - ${test.max_tries}`;
      }
      return 'Тест можно проходить неограниченное количество раз';
    },
    toggleClass() {
      this.isActive = !this.isActive;
    },
  },
  watch: {
    currentSpecialization() {
      this.testInProgress = false;
      this.currentAnswers = null;
      this.currentQuestionIndex = 1;
      this.currentTry = null;
      this.testFailedMessage = '';
    },
    currentTry: {
      handler(value) {
        if (value) {
          this.currentQuestionIndex = value.step;
          this.$nextTick(() => {
            this.disableQuestionButtons(value);
          });
        }
      },
      deep: true,
    },
    selectedItem() {
      this.cancelTest();
    },
    testPassed(value) {
      if (value) {
        this.loadMySpecializations();
      }
    },
    specializations(newArray) {
      if (!newArray.length) {
        return;
      }
      this.selectedSpecialization = newArray[0].id;
    },
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Специализации');
    this.$store.dispatch('specializations/GetList').then(() => {
      this.loadMySpecializations();
    });
  },
};
